import { useLang } from '@/i18n';
import EcoTextTc from 'eco-design/sections/eco-text-tc';
import React from 'react';
import css from './index.module.scss';
import EcoSectionCommon from 'eco-design/elements/eco-section-common';

const FQA: React.FC = () => {
    const { t } = useLang('TrailSeries.FQA');

    const items = [
        {
            isOpen: true,
            title: t('title1'),
            desc: t('desc1'),
        },
        {
            isOpen: false,
            title: t('title2'),
            desc: t('desc2'),
        },
        {
            isOpen: false,
            title: t('title3'),
            desc: t('desc3'),
        },

        {
            isOpen: false,
            title: t('title4'),
            desc: t('desc4'),
        },
        {
            isOpen: false,
            title: t('title5'),
            desc: t('desc5'),
        },
        {
            isOpen: false,
            title: t('title6'),
            desc: t('desc6'),
        },
        {
            isOpen: false,
            title: t('title7'),
            desc: t('desc7'),
        },
    ];
    return (
        <div className={`${css.comp} GtmModuleData-section`} data-section-id="FAQ">
            <EcoSectionCommon title={t('title')} desc={t('desc')} />
            <EcoTextTc items={items} />
        </div>
    );
};
export default FQA;
